var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-panel"},[_c('date-panel',{ref:"datePanel",attrs:{"picker-options":_vm.pickerOptions},on:{"pick":_vm.pick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }